import React, { useEffect, useState, useContext } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useRazorPay } from '../../hooks/razorPay/useRazorPay'
import { useCompany } from '../../hooks/SuperAdmin/useCompany'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'
import { sortByName } from '../../shared/constants'
import Layout from '../../components/Layout'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import moment from 'moment'
import S3 from 'react-aws-s3'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import CustomInput from '../../components/CustomInput'

import countries from '../../utils/country.json'
import { getAllData } from '../../lib/RestApi/customApiHandler'
import { useQuery } from 'react-query'

export default function AddCompany({ company }) {
  const { data: permissions, isLoading } = useQuery(['permissions'], () => getAllData('permissions'))
  const [image, setImage] = useState('')

  console.log({
    first: permissions?.data,
  })

  const [companyData, setCompanyData] = useState({
    companyAdminCode: '',
    email: '',
    name: '',
    dob: new Date().toISOString(),
    password: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    active: true,
    domain: '',
    country: '',
    employeeCount: '',
    countryCode: '',
    expiryDate: '',
    // permissions: '',
    companyPermissions: '',
    subscription: '',
    offlinePayment: false,
    offlinePaymentRefNumber: 0,
    imageCaptureDuringAttendance: false,
  })

  const { addCompany, loading, updateCompany, company: resCompany } = useCompany()
  const { trySubscription, purchaseSubscription } = useRazorPay()
  const { subscriptions } = useContext(SuperAdminContext)
  const { getAllSubscriptions } = useSubscription()

  const handleCompany = () => {
    if (company) {
      updateCompany({ ...companyData, companyId: company._id })
    } else {
      console.log({ companyData })
      let subscriptionId = companyData.subscription._id
      let permissionId = companyData.subscription.modules._id
      addCompany({ ...companyData, companyPermissions: permissionId, subscription: subscriptionId, logo: image })
    }
  }

  useEffect(() => {
    if (company) {
      setCompanyData({ ...company })
    }
  }, [company])

  useEffect(() => {
    if (resCompany) {
      console.log('resCompany', resCompany)
      trySubscription({
        subscriptionId: companyData.subscription._id,
        validityPeriod: companyData.subscription.validityPeriod,
        amount: companyData.subscription.amount,
        companyAdminId: resCompany?._id,
        offlinePayment: companyData.offlinePayment,
        offlinePaymentRefNumber: companyData.offlinePaymentRefNumber,
        fromAdmin: true,
      })
    }
  }, [resCompany])

  useEffect(() => {
    console.log('image', image)
  }, [image])

  useEffect(() => {
    getAllSubscriptions()
  }, [])

  const data = [
    { label: 'Company Code', value: companyData.companyAdminCode, name: 'companyAdminCode' },
    { label: 'Company Name', value: companyData.name, name: 'name' },
    { label: 'Domain', value: companyData.domain, name: 'domain' },
    { label: 'Country', value: companyData.country, name: 'country', options: sortByName(countries, 'name'), fieldName: 'name', fieldValue: 'name' },
    { label: 'Total Employees', value: companyData.employeeCount, name: 'employeeCount', type: 'NUMBER' },
    { label: 'First Name', value: companyData.firstName, name: 'firstName' },
    { label: 'Last Name', value: companyData.lastName, name: 'lastName' },
    // { label: 'DOB', value: companyData.dob, name: 'dob', type: 'DATE' },
    { label: 'Email', value: companyData.email, name: 'email', conditions: [{ type: 'EMAIL' }] },
    { label: 'Password', value: companyData.password, name: 'password', type: 'password', noDisplay: company ? true : false },
    { label: 'Country Code', value: companyData.countryCode, name: 'countryCode', options: sortByName(countries, 'name'), fieldName: 'name', fieldValue: 'phone' },
    {
      label: 'Phone Number',
      value: companyData.phoneNumber,
      name: 'phoneNumber',
      conditions: [{ type: 'PHONE' }],
      type: 'NUMBER',
    },
    { label: 'Expiry Date', value: companyData.expiryDate, name: 'expiryDate', type: 'date', Min: moment(new Date()).format('YYYY-MM-DD') },
    { label: 'Subscription', value: companyData.subscription, name: 'subscription', options: subscriptions?.subscriptions, fieldName: 'subscriptionName', completeOption: true },
    // { label: 'Admin Permissions', value: companyData.permissions, name: 'permissions', options: permissions?.data, fieldName: 'name', fieldValue: '_id'},
    { label: 'Offline Payment', value: companyData.offlinePayment, name: 'offlinePayment', type: 'SWITCH' },
    {
      label: 'Offline Payment Reference Number',
      name: 'offlinePaymentRefNumber',
      value: companyData.offlinePaymentRefNumber,
      noValidate: !companyData.offlinePayment,
      disabled: !companyData.offlinePayment,
    },
    { label: 'Status', value: companyData.active, type: 'ACTIVE' },
    { label: 'Image Capture During Attendance', value: companyData.imageCaptureDuringAttendance, type: 'SWITCH' },
    // {
    //   // label: 'Company Logo',
    //   // name: 'logo',
    //   handleChange: setImage,
    //   type: 'file',
    //   single: true,
    //   // multiple: false,
    //   // handleFile: handleFile
    // },
  ]

  console.log({ companyData })

  return (
    <Layout
      heading={`Company`}
      heading2={` ${company ? 'Edit' : 'Add'}`}
      // url1={ROUTES.MY_TMPORDERS}
      none
    >
      <HeaderTabLayout
        heading={`${companyData ? 'Edit' : 'Add'}  Product `}
        state={companyData}
        setState={setCompanyData}
        content={
          <>
            <CustomAddForm
              // heading="Company" redirect="ALL_COMPANIES" currentData={company}
              loading={loading}
              state={companyData}
              setState={setCompanyData}
              data={data}
              //  handleClick={handleCompany} inputFields={data}
            />
            <CustomInput
              label={'Company Logo'}
              handleChange={setImage}
              type="file"
              single={true}
              // single= {true}
            />

            {(image !== '' || company) && (
              <div>
                <img style={{ margin: '10px', width: '200px', height: '200px', display: 'flex', objectFit: 'cover', borderRadius: '10px' }} src={image || company.logo} alt="company logo" />
              </div>
            )}
          </>

          // <TmpOrderForm state={id!==undefined? editForm : form} setState={id!==undefined? setEditForm : setform} />
        }
        addContent={handleCompany}
        text={`${company ? 'Update' : 'Add'}`}
        // redirect={ROUTES.ADD_TMPORDER}
        loading={loading}
      />
    </Layout>
  )
}
